// Fixed, animated gradient blobs behind all page content.

export default function AnimatedBackground() {
  return (
    <div className="gc-bg" aria-hidden="true">
      <div className="gc-bg-blob b1" />
      <div className="gc-bg-blob b2" />
      <div className="gc-bg-blob b3" />
      <div className="gc-bg-vignette" />
    </div>
  );
}
